import _slicedToArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _ from 'lodash';
import SHARED_ROUTES from '../routes';
export function buildBaseRoute() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isDemo = _ref.isDemo,
    isKiosk = _ref.isKiosk,
    isEmbedded = _ref.isEmbedded,
    isStoreFront = _ref.isStoreFront,
    isMobileEcommApp = _ref.isMobileEcommApp,
    dispensary = _ref.dispensary;
  var href, route;
  if (isDemo) {
    href = SHARED_ROUTES.DEMO;
    route = SHARED_ROUTES.DEMO;
  } else if (isKiosk) {
    href = SHARED_ROUTES.KIOSKS;
    route = SHARED_ROUTES.KIOSKS;
  } else if (isEmbedded) {
    href = SHARED_ROUTES.EMBEDDED_MENU;
    route = SHARED_ROUTES.EMBEDDED_MENU;
  } else if (isMobileEcommApp) {
    href = SHARED_ROUTES.MOBILE_ECOMM;
    route = SHARED_ROUTES.MOBILE_ECOMM;
  } else if (isStoreFront) {
    href = SHARED_ROUTES.STORES;
    route = SHARED_ROUTES.STORES;
  } else if (dispensary) {
    href = SHARED_ROUTES.DISPENSARY;
    route = SHARED_ROUTES.DISPENSARY;
  } else {
    href = SHARED_ROUTES.SHOP;
    route = SHARED_ROUTES.SHOP;
  }
  return [href, route];
}
export function addDispensaryRoutes() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    href = _ref2.href,
    route = _ref2.route,
    dispensary = _ref2.dispensary,
    info = _ref2.info;
  if (dispensary && info) {
    href += "/".concat(dispensary.cName).concat(SHARED_ROUTES.INFO);
    route += SHARED_ROUTES.CNAME_INFO;
  } else if (dispensary) {
    href += "/".concat(dispensary.cName);
    route += SHARED_ROUTES.CNAME;
  }
  return [href, route];
}
export function addProductRoutes(_ref3) {
  var _ref4, _product$cName;
  var href = _ref3.href,
    route = _ref3.route,
    product = _ref3.product;
  href += "".concat(SHARED_ROUTES.PRODUCT).concat((_ref4 = (_product$cName = product.cName) !== null && _product$cName !== void 0 ? _product$cName : product.id) !== null && _ref4 !== void 0 ? _ref4 : product._id);
  route += SHARED_ROUTES.PRODUCT_ID;
  return [href, route];
}
export function addMenuSectionRoutes(_ref5) {
  var href = _ref5.href,
    route = _ref5.route,
    menuSection = _ref5.menuSection;
  href += "".concat(SHARED_ROUTES.MENU_SECTION).concat(menuSection.id);
  route += SHARED_ROUTES.MENU_SECTION_ID;
  return [href, route];
}
export function addSpecialsRoutes(_ref6) {
  var href = _ref6.href,
    route = _ref6.route,
    id = _ref6.id,
    currentRoute = _ref6.currentRoute,
    specialId = _ref6.specialId;
  href += SHARED_ROUTES.SPECIALS;
  route += SHARED_ROUTES.SPECIALS;
  var generatedOfferSubroute = _.includes(id, 'offer');
  var generatedSaleSubroute = _.includes(id, 'sale');
  if (!generatedOfferSubroute && !generatedSaleSubroute && id) {
    href += "/".concat(id || specialId);
    route += SHARED_ROUTES.OFFER_SPECIAL_ID;
  }
  if (generatedOfferSubroute) {
    href += "/".concat(id || specialId);
    route += SHARED_ROUTES.OFFER_SPECIAL_ID;
  } else if (generatedSaleSubroute) {
    href += "/".concat(id || specialId);
    route += SHARED_ROUTES.SALE_SPECIAL_ID;
  }
  if (!id) {
    if (_.includes(currentRoute, 'offer')) {
      href += "".concat(SHARED_ROUTES.OFFER, "/").concat(specialId);
      route += SHARED_ROUTES.OFFER_SPECIAL_ID;
    } else if (_.includes(currentRoute, 'sale')) {
      href += "".concat(SHARED_ROUTES.SALE, "/").concat(specialId);
      route += SHARED_ROUTES.SALE_SPECIAL_ID;
    }
  }
  return [href, route];
}
export function buildExternalTemplateRoute(_ref7) {
  var routeRoot = _ref7.routeRoot,
    brands = _ref7.brands,
    category = _ref7.category,
    product = _ref7.product,
    subcategory = _ref7.subcategory,
    specials = _ref7.specials;
  var href = routeRoot;
  if (brands) {
    href += "?dtche[path]=brands&dtche[brands]=".concat(encodeURIComponent(brands));
  } else if (specials) {
    href += "?dtche[path]=specials";
  } else if (product) {
    href += "?dtche[product]=".concat(encodeURIComponent(product.cName || product.id));
  } else if (category && category.key) {
    href += "?dtche[category]=".concat(encodeURIComponent(category.key));
    if (subcategory) {
      href += "?dtche[subcategory]=".concat(encodeURIComponent(subcategory));
    }
  }
  return {
    href: href
  };
}
export function buildStoreFrontRoute(_ref8) {
  var routeRoot = _ref8.routeRoot,
    brands = _ref8.brands,
    category = _ref8.category,
    product = _ref8.product,
    subcategory = _ref8.subcategory,
    specials = _ref8.specials;
  var href = routeRoot;
  if (brands) {
    href += "".concat(SHARED_ROUTES.BRANDS, "?brands=").concat(encodeURIComponent(brands));
  } else if (specials) {
    href += SHARED_ROUTES.SPECIALS;
  } else if (product) {
    href += SHARED_ROUTES.PRODUCT + encodeURIComponent(product.cName || product.id);
  } else if (category && category.key) {
    href += SHARED_ROUTES.PRODUCTS + encodeURIComponent(category.key);
    if (subcategory) {
      href += "/".concat(encodeURIComponent(subcategory));
    }
  }
  return {
    href: href
  };
}
export function isStoreFrontRouteRoot(routeRoot) {
  if (!routeRoot || !_.isString(routeRoot)) {
    return false;
  }

  // Normalize the route by removing trailing slashes to prevent split() issues
  var normalizedRoute = routeRoot.replace(/\/+$/, '');
  var splitRoute = _.split(normalizedRoute, '/');

  // Storefront routes have one of two patterns:
  // domain/store/{cName} || domain/stores/{cName}
  return splitRoute.length > 1 && _.includes(['stores', 'store'], splitRoute[splitRoute.length - 2]);
}
export function buildCheckoutRoute(_ref9) {
  var dispensary = _ref9.dispensary,
    isDemo = _ref9.isDemo,
    isStoreFront = _ref9.isStoreFront,
    isEmbedded = _ref9.isEmbedded,
    isMobileEcommApp = _ref9.isMobileEcommApp;
  var href, route;
  if (isDemo) {
    href = SHARED_ROUTES.DEMO;
    route = SHARED_ROUTES.DEMO;
  } else if (isEmbedded && dispensary) {
    // embedded-menu has its own checkout route
    href = "".concat(SHARED_ROUTES.EMBEDDED_MENU, "/").concat(dispensary.cName);
    route = SHARED_ROUTES.EMBEDDED_MENU_CNAME;
  } else if (isStoreFront && dispensary) {
    // storefront has its own checkout route
    href = "".concat(SHARED_ROUTES.STORES, "/").concat(dispensary.cName);
    route = SHARED_ROUTES.STORES_CNAME;
  } else if (isMobileEcommApp && dispensary) {
    // mobile ecomm has its own checkout route
    href = "".concat(SHARED_ROUTES.MOBILE_ECOMM, "/").concat(dispensary.cName);
    route = SHARED_ROUTES.MOBILE_ECOMM;
  } else if (dispensary !== null && dispensary !== void 0 && dispensary.cName) {
    href = "".concat(SHARED_ROUTES.DISPENSARY, "/").concat(dispensary.cName);
    route = SHARED_ROUTES.DISPENSARY_CNAME;
  } else {
    href = '';
    route = '';
  }
  href += SHARED_ROUTES.CHECKOUT;
  route += SHARED_ROUTES.CHECKOUT;
  return [href, route];
}
export function buildHomeRoute() {
  return ["/", "/"];
}
export function buildDispensariesRoute() {
  return [SHARED_ROUTES.DISPENSARIES, SHARED_ROUTES.DISPENSARIES];
}
export function addCategoryRoute(_ref10) {
  var href = _ref10.href,
    route = _ref10.route,
    category = _ref10.category,
    subcategory = _ref10.subcategory;
  // maybe we're passed the object, maybe we're passed the key
  var categoryKey = category.key || category;
  var subcategoryKey = (subcategory === null || subcategory === void 0 ? void 0 : subcategory.key) || subcategory;
  if (subcategoryKey) {
    href += "".concat(SHARED_ROUTES.PRODUCTS).concat(categoryKey, "/").concat(subcategoryKey);
    route += SHARED_ROUTES.SUBCATEGORY;
  } else {
    href += "".concat(SHARED_ROUTES.PRODUCTS).concat(categoryKey);
    route += SHARED_ROUTES.PRODUCTS_CATEGORY;
  }
  return [href, route];
}

/**
 * Create a route and href based on a given UI state
 * @param {{ isDemo: boolean, isKiosk: boolean, isEmbedded: boolean, isStoreFront: boolean, isMobileEcommApp: boolean, dispensary, category: string, subcategory?: string }} options
 */
export function buildCategoryRoute(_ref11) {
  var isDemo = _ref11.isDemo,
    isKiosk = _ref11.isKiosk,
    isEmbedded = _ref11.isEmbedded,
    isStoreFront = _ref11.isStoreFront,
    isMobileEcommApp = _ref11.isMobileEcommApp,
    dispensary = _ref11.dispensary,
    category = _ref11.category,
    subcategory = _ref11.subcategory;
  var _buildBaseRoute = buildBaseRoute({
      isDemo: isDemo,
      isKiosk: isKiosk,
      isEmbedded: isEmbedded,
      isStoreFront: isStoreFront,
      isMobileEcommApp: isMobileEcommApp,
      dispensary: dispensary
    }),
    _buildBaseRoute2 = _slicedToArray(_buildBaseRoute, 2),
    href = _buildBaseRoute2[0],
    route = _buildBaseRoute2[1];
  var _addDispensaryRoutes = addDispensaryRoutes({
    href: href,
    route: route,
    dispensary: dispensary
  });
  var _addDispensaryRoutes2 = _slicedToArray(_addDispensaryRoutes, 2);
  href = _addDispensaryRoutes2[0];
  route = _addDispensaryRoutes2[1];
  var _addCategoryRoute = addCategoryRoute({
    href: href,
    route: route,
    category: category,
    subcategory: subcategory
  });
  var _addCategoryRoute2 = _slicedToArray(_addCategoryRoute, 2);
  href = _addCategoryRoute2[0];
  route = _addCategoryRoute2[1];
  return [href, route];
}